export default {"src":"/_next/static/image/public/images/ic_maximize.79f3c9b4363cdf6b949f82df7995965f.svg","height":23,"width":23};